// import { ifAuthenticated } from "@/Modules/Auth/Auth/Routes/guards"
export default [
  // {
  //   path: "/settings",
  //   name: "settings",
  //   meta: { title: "Settings" },
  //   component: () => import(/* webpackChunkName: "Settings" */ "@/Modules/Auth/Settings/Views/Settings/Details.vue")
  //   // beforeEnter: ifAuthenticated
  // }
]
